// Empty in local dev → calls go to https://localhost:3002/api/* which Vite
// proxies to http://localhost:3000 (the pontifexx-agents dev server).
// Set VITE_API_BASE to the prod agents URL for production builds.
export const API_BASE: string = import.meta.env.VITE_API_BASE ?? "";
